import request from "superagent";

import Configuration from './Configuration';

/**
 * Class exposing the necessaries PSA API methods
 */

class Api {
    /**
     * Returns the vehicles data
     *
     * @returns {Promise<any>}
     */
    getVehicles() {
        return new Promise((resolve, reject) => {
            request
                .get(`${Configuration.apiEndpoint}/vehicles`)
                .accept("application/json")
                .query({
                    country: Configuration.country,
                    brand: Configuration.brand,
                    language: Configuration.language,
                    vehicleUse: Configuration.vehicleUse,
                    disableCache: Configuration.disableCache,
                })
                .on('error', err => {
                    reject(err);
                })
                .end((err, res) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(res.body);
                    }
                });
        });
    }

    /**
     * Retrieve additional features data such as rims and look features for a given vehicle.
     *
     * @param {string} lcdv16
     *
     * @returns {Promise<any>}
     */
    getFeatures(lcdv16) {
        console.log(Configuration.disableCache);
        console.log(Configuration.brand);
        console.log(Configuration.language);
        return new Promise((resolve, reject) => {
            request
                .get(`${Configuration.apiEndpoint}/features`)
                .accept("application/json")
                .query({
                    country: Configuration.country,
                    brand: Configuration.brand,
                    language: Configuration.language,
                    vehicleUse: Configuration.vehicleUse,
                    version: lcdv16,
                    disableCache: Configuration.disableCache
                })
                .on('error', err => {
                    reject(err);
                })
                .end((err, res) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(res.body);
                    }
                });
        });
    }

    /**
     * Call the average consumption calculation
     * 
     * @param {string} lcdv16               The LCDV16 depending on user choices
     * @param {string} rimsLabel            The rims label chosen by the user
     * @param {string} colorExtInt          The color details depending on rims choice
     * @param {string} nbOptions            The option count depending on rims choice
     * @param {string} options5C            The options5C depending on rims choice
     * @param {string} options7C            The options7C depending on rims choice
     * @param {string} extendedAttributes   The extended attributes depending on rims choice
     *
     * @returns {Promise<any>}
     */
    calculateAverageConsumption(lcdv16, rimsLabel,rimsCode, colorExtInt, nbOptions, options5C, options7C, extendedAttributes = '') {
        return new Promise((resolve, reject) => {
            // Wheel label is sent only if it start by 2 integers
            const wheelLabel = /^[0-9]{2}/g.test(rimsLabel) ? rimsLabel : "00 - No rims data";

            request
                .post(`${Configuration.apiEndpoint}/consumptions/average`)
                .set('Content-Type', 'application/json')
                .send({
                    countryCode : Configuration.country,
                    version16C : lcdv16,
                    wheelLabel : wheelLabel,
                    wheelCode : rimsCode,
                    colorExtInt : colorExtInt,
                    nbOptions : nbOptions,
                    options5C : options5C,
                    options7C : options7C,
                    extendedAttributes : extendedAttributes
                })
                .on('error', err => {
                    reject(err);
                })
                .then((res, err) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(res.body);
                    }
                });
        });
    }

    /**
     * Call the usage consumption calculation
     * 
     * @param {object} data The user choices
     * @param {object} consumptionData The average consumption data from step 1
     * @param {string} lcdv16 The LCDV16 depending on user choices
     *
     * @returns {Promise<any>}
     */
    calculateUsageConsumption(data, consumptionData, lcdv16) {
        return new Promise((resolve, reject) => {
            request
                .post(`${Configuration.apiEndpoint}/consumptions/refined`)
                .set('Content-Type', 'application/json')
                .send({
                    countryCode: Configuration.country,
                    step1MeasureReference : consumptionData.reference,
                    step1AverageConsumption : consumptionData.consumption,
                    step1NOx : consumptionData.nox,
                    step1Particles : consumptionData.pn,
                    version16C : lcdv16,
                    rank2 : data.rank2,
                    rank3 : data.rank3,
                    fullcar : data.fullcar,
                    luggage : data.luggage,
                    averageTripLength : data.averageTripLength,
                    nbTripsPerDay : data.nbTripsPerDay,
                    mixCity : data.mixCity,
                    mixRoad : data.mixRoad,
                    mixMotorway : data.mixMotorway,
                    drivingSpeed : data.drivingSpeed,
                    drivingBehaviour : data.drivingBehaviour
                })
                .on('error', err => {
                    reject(err);
                })
                .then((res, err) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(res.body);
                    }
                });
        });
    }

    /**
     * Returns the car's image url for the given version.
     *
     * @param {string} version
     *
     * @returns {string}
     */
    getVehicleImageUrl(version) {
        const endpoint = `https://visuel3d-secure.${Configuration.brand === 'P' ? 'peugeot' : 'citroen'}.com/V3DImage.ashx`;
        const client = "CUS";
        const format = "png";
        return `${endpoint}?client=${client}&format=${format}&version=${version}`;
    }

    /**
     * Returns the translation for the given country/lang
     * 
     * @param {string} country
     * @param {string} language
     * 
     * @returns {Promise<any>}
     */
    getTranslation = (country, language) => {
        return new Promise((resolve, reject) => {
            request
                .get(`${Configuration.apiEndpoint}/translations`)
                .accept("application/json")
                .query({
                    country: Configuration.country,
                    language: Configuration.language
                })
                .on('error', err => {
                    resolve({});
                })
                .end((err, res) => {
                    resolve(err ? {} : res.body);
                });
        });
    }
}

export default new Api();


// WEBPACK FOOTER //
// ./src/Api.js